import * as RadixAlertDialog from '@radix-ui/react-alert-dialog';

import * as S from './style';

export const DeletedAlertDialog = {
  Root: RadixAlertDialog.Root,
  Portal: RadixAlertDialog.Portal,
  Overlay: S.Overlay,
  Content: S.Content,
  Title: S.Title,
};
